import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from './firebase';
import logo from '../assets/logos/KUROCO_left corner_logo.png';

const ForgotPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const prefilledEmail = searchParams.get('email') || '';

  const [email, setEmail] = useState(prefilledEmail);
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await sendPasswordResetEmail(auth, email.trim());
      setSent(true);
    } catch (err) {
      if (err.code === 'auth/user-not-found') {
        setSent(true);
      } else {
        setError(err.message);
      }
    } finally {
      setSubmitting(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-[#E4E7E6]">
        <div className="w-full max-w-[420px] rounded-xl shadow-lg p-8 md:p-10 bg-white border border-gray-200 text-center">
          <div className="flex justify-center mb-6">
            <div className="inline-flex px-5 py-3 bg-gray-50 rounded-lg">
              <img src={logo} alt="KUROCO" className="h-7 object-contain" />
            </div>
          </div>
          <h1 className="text-[#1a1a1a] text-lg font-semibold mb-4">メールを送信しました</h1>
          <p className="text-gray-600 text-sm leading-relaxed mb-2">
            メールアドレスが登録されている場合、パスワード再設定用のメールを送信しました。ご確認ください。
          </p>
          <p className="text-gray-500 text-xs mb-6">
            メールが届かない場合は、迷惑メールフォルダをご確認ください。
          </p>
          <Link to="/login" className="text-[#33564B] font-medium hover:underline">
            ログイン画面に戻る
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#E4E7E6]">
      <div className="w-full max-w-[420px] rounded-xl shadow-lg p-8 md:p-10 bg-white border border-gray-200">
        <div className="flex justify-center mb-6">
          <div className="inline-flex px-5 py-3 bg-gray-50 rounded-lg">
            <img src={logo} alt="KUROCO" className="h-7 object-contain" />
          </div>
        </div>
        <h1 className="text-[#1a1a1a] text-center text-lg font-semibold mb-2">パスワードをお忘れですか？</h1>
        <p className="text-gray-500 text-center text-sm mb-6">
          メールアドレスを入力してください。パスワード再設定用のリンクをお送りします。
        </p>

        {error && (
          <div className="mb-5 p-3 rounded-lg text-[13px] text-red-700 bg-red-50 border border-red-200">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="メールアドレス"
              required
              className="w-full px-4 py-3 text-sm rounded-lg outline-none border border-gray-300 bg-gray-50 text-[#1a1a1a] placeholder:text-gray-400 focus:border-[#33564B] focus:bg-white"
            />
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="w-full py-3.5 text-[15px] font-semibold text-white rounded-lg disabled:opacity-50 disabled:cursor-wait bg-[#33564B] hover:bg-[#2a463d]"
          >
            {submitting ? '送信中...' : '送信'}
          </button>
        </form>

        <p className="mt-6 text-center text-sm text-gray-500">
          <Link to="/login" className="text-[#33564B] hover:underline font-medium">
            ログイン画面に戻る
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
